import { reactive } from 'vue'

// Dark mode is not product-supported yet — always light appearance.
const darkMode = reactive({
	enabled: false,
	toggle() {
		// no-op until dark theme is fully implemented
	},
})

const useDarkMode = () => ({ darkMode })

export default useDarkMode
